<template lang="pug">
  #inicio-respuesta
    .container-fluid
      .row
        .title.mx-auto.d-flex
          img(src="/assets/img/microsite/LaRespuesta.png")
      .row.content.d-flex.align-items-md-center.align-items-end
        .col-11.col-md-7.text.px-4.d-flex.my-0.my-md-5
          p.sub-title.default-text.mb-0 ¿Quién puede hacer
          p.sub-title.default-yellow-text.bold cuarentena en México?
          p.subtext.default-text.bold En México, el hambre puede ser tan amenazante como el coronavirus y hacer cuarentena es un privilegio. ¿Quiénes pueden y quiénes no quedarse en casa para protegerse de la enfermedad?
          router-link.story-btn(to="/la-respuesta#ch2intro") Leer Blog
        .col-md-5.right.pr-0
            img.back-img(src="/assets/img/microsite/yellow-desktopok.png")
</template>
<script>
export default {
  name: "Section2"
};
</script>

<style lang="scss">
#inicio-respuesta {
  min-height: 100vh;
  padding: 1rem 0;
  margin-bottom: 10rem;
  .title {
    justify-content: center;
    align-items: center;
    img {
      width: 30vw;
      max-width: 350px;
    }
  }
  .content {
    min-height: 85vh;
    background-image: url("/assets/img/microsite/Oval_BlogAmarilloDesktop.png");
    background-size: 100% 100%;
    //text-align: center;
    justify-content: center;
    align-items: flex-end;
    .right {
      align-self: center;
      .back-img {
        width: 100%;
        height: auto;
        text-align: right;
      }
    }
    .text {
      min-height: 45vh;
      flex-direction: column;
      text-align: center;
      justify-content: center;
      align-items: center;
      line-height: 1;
      .subtext {
        line-height: 1.75;
      }
      a {
        color: #0a1d59;
      }
      .story-btn {
        font-family: "Oswald", sans-serif;
        border: solid 3px #0a1d59;
        border-radius: 45px;
        font-size: 1.2rem;
        padding: 0.5rem 3.5rem;
      }
      .story-btn:hover {
        background-color: #0a1d59;
        color: #fff;
      }
    }
  }
}
@media (max-width: 500px) {
  #inicio-respuesta {
    .title {
      img {
        width: auto;
        max-width: 225px;
      }
    }
  }
}
// Small devices
@media (max-width: 767px) {
  #inicio-respuesta {
    // .title {
    //   img {
    //     width: auto;
    //     max-width: 70vw;
    //   }
    // }
    .sub-title {
      font-size: 1.7rem;
    }
    .content {
      background-image: url("/assets/img/microsite/yellow-mobile.png");
      padding: 2rem 0;
      align-items: flex-end;
      .text {
        .subtext {
          line-height: 1.5;
          max-width: 90%;
        }
        .story-btn {
          font-family: "Oswald", sans-serif;
          font-size: 1rem;
          border: solid 2px #0a1d59;
          padding: 0.5rem 2.5rem;
          margin: 0.8rem auto 0.8rem auto;
        }
      }
    }
    .right {
      display: none;
    }
  }
}
</style>
